import {
  ColumnConfig,
  ITableCell,
  TableRowProps,
} from '@urbanx/agx-ui-components'
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { IListingDiscrepancy } from 'types/rex'

const columnConfig = [
  { name: 'Agency Name', widthInfo: { percent: 12 } },
  { name: 'Agent Name', widthInfo: { percent: 12 } },
  { name: 'Property Address' },
  { name: 'Listing ID', widthInfo: { percent: 9 } },
  { name: 'Created Date', widthInfo: { percent: 9 } },
  { name: 'Exists In', widthInfo: { percent: 9 } },
] satisfies ColumnConfig[]

const useListingDiscrepanciesTableConfig = (
  discrepancies: IListingDiscrepancy[],
): [ColumnConfig[], TableRowProps[]] => {
  const rows = useMemo(() =>
    discrepancies.map((discrepancy, index) => {
      const cells: ITableCell[] = [
        {
          columnConfig: columnConfig[0],
          children: discrepancy?.agencyName,
        },
        {
          columnConfig: columnConfig[1],
          children: discrepancy?.agentName,
        },
        {
          columnConfig: columnConfig[2],
          children: discrepancy?.propertyAddress
        },
        {
          columnConfig: columnConfig[3],
          children: discrepancy?.listingId
        },
        {
          columnConfig: columnConfig[4],
          children: discrepancy?.createdDate ?
            dayjs(discrepancy.createdDate).format('DD/MM/YYYY') : ''
        },
        {
          columnConfig: columnConfig[5],
          children: discrepancy?.existsInAutopilot ?
            'Autopilot' : 'REX'
        }
      ]

      return {
        cells: cells,
        id: `discrepancy-${index}`,
        isMobile: false,
      } satisfies TableRowProps
    }),
  [discrepancies, columnConfig]);

  return [columnConfig, rows]
}

export default useListingDiscrepanciesTableConfig
